import auth from './auth';
import request from './request';
import opendata from './opendata';
import person from './basic/person';
import lifeClass from './basic/lifeClass';
import studyYear from './study/studyYear';
import book from './exam/book';
import bookList from './exam/bookList';
import addPointsApply from './exam/addPointsApply';
import fivePointsEach from './score/fivePointsEach';
import orderBy from './orderBy/orderBy';
import user from './user/user';
import eventsLog from './eventsLog';
export default {
  auth,
  request,
  opendata,
  person,
  lifeClass,
  studyYear,
  book,
  bookList,
  addPointsApply,
  fivePointsEach,
  orderBy,
  user,
  eventsLog
};